$(function(){

	var nav_mobile_wrapper_selector = '.cms-nav-mobile-wrapper',
		nav_mobile_open_class = 'cms-nav-mobile-open',
		nav_mobile_open_button_selector = '.cms-nav-button',
		nav_mobile_close_button_selector = '.cms-nav-mobile-close-button-wrapper';

	$(nav_mobile_close_button_selector).on('click', function() {

		$(nav_mobile_wrapper_selector).removeClass(nav_mobile_open_class);
		window.bodyScrollUnlock();

	});

	$(nav_mobile_open_button_selector).on('click', function() {

		$(nav_mobile_wrapper_selector).addClass(nav_mobile_open_class);
		window.bodyScrollLock();

	});

	$('.cms-nav-item-subnav-toggle').on('click', function() {

		var self = $(this),
			nav_item = self.closest('li');

		nav_item.toggleClass('cms-nav-item-subnav-is-open');

	});

	// display current menu item as active and oben subnavs
	$('.cms-nav-item-current').each(function(){

		var current_item = $(this);
		current_item.parents('li').addClass('cms-nav-item-subnav-is-open');

	});

});